/**
 * Announcement link catalog (Jul 2026) — the single source of truth for
 * internal destinations the Global Announcement Bar may point to.
 *
 * `roles: null` = every authenticated role. Otherwise the link is shown
 * ONLY to the listed roles (mirrors App.js ProtectedRoute allowedRoles)
 * so no user ever taps a link that lands on a 403.
 */
export const ANNOUNCEMENT_LINKS = [
  { path: '/dashboard',          label: 'لوحة التحكم',           roles: null },
  { path: '/communications-center', label: 'مركز الإعلانات والإشعارات', roles: ['Student', 'Teacher', 'Parent'] },
  { path: '/my-assignments',     label: 'واجباتي (الطلاب)',       roles: ['Student'] },
  { path: '/settings',           label: 'الإعدادات',              roles: null },
  { path: '/leaderboard',        label: 'لوحة الشرف',            roles: null },
  { path: '/my-assessments',     label: 'اختباراتي (الطلاب)',     roles: ['Student'] },
  { path: '/my-excuses',         label: 'أعذار الغياب (الطلاب)',  roles: ['Student', 'Parent'] },
  { path: '/student-guide',      label: 'دليل الطالب',            roles: ['Student', 'Super_Admin', 'Academic_Supervisor', 'Parent'] },
  { path: '/badges',             label: 'الشارات والإنجازات',     roles: ['Student', 'Teacher', 'Super_Admin', 'Academic_Supervisor'] },
  { path: '/support/my-requests', label: 'طلبات الدعم',           roles: ['Student', 'Parent', 'Teacher'] },
  { path: '/assignments',        label: 'الواجبات',               roles: ['Super_Admin', 'Academic_Supervisor', 'Teacher', 'Student', 'Parent'] },
  { path: '/assessments',        label: 'إدارة الاختبارات',       roles: ['Super_Admin', 'Academic_Supervisor', 'Teacher'] },
  { path: '/grading-queue',      label: 'قائمة التصحيح',          roles: ['Super_Admin', 'Academic_Supervisor', 'Teacher'] },
  { path: '/classrooms',         label: 'القاعات الدراسية',       roles: ['Super_Admin', 'Academic_Supervisor', 'Teacher'] },
  { path: '/teacher/shifts',     label: 'جدول المناوبات (المعلمون)', roles: ['Teacher'] },
  { path: '/students',           label: 'إدارة الطلاب',           roles: ['Super_Admin', 'Academic_Supervisor', 'Registration_Officer'] },
  { path: '/finance-hub',        label: 'المالية',                roles: ['Super_Admin', 'Financial_Manager', 'Academic_Supervisor'] },
  { path: '/referrals',          label: 'نظام الإحالات (الطلاب)', roles: ['Student'] },
  { path: '/admin/referrals',    label: 'إدارة الإحالات',         roles: ['Super_Admin', 'Financial_Manager', 'Academic_Supervisor', 'Registration_Officer'] },
  { path: '/reports-hub',        label: 'التقارير والتحليلات',    roles: ['Super_Admin', 'Academic_Supervisor'] },
];

/**
 * Can `role` open `url`? External http(s) links are always allowed.
 * Internal paths must exist in the catalog AND include the role —
 * unknown internal paths are hidden (fail-safe: never risk a 403).
 */
export const canRoleAccessLink = (url, role) => {
  if (!url) return false;
  if (url.startsWith('http://') || url.startsWith('https://')) return true;
  const base = url.split(/[?#]/)[0];
  const entry = ANNOUNCEMENT_LINKS.find((l) => l.path === base);
  if (!entry) return false;
  return entry.roles === null || entry.roles.includes(role);
};
